import * as v from 'valibot';

export const windowWebFeaturesSchema = v.object({
  'flashcards-v2': v.optional(v.boolean()),
  loginfb: v.optional(v.boolean()),
  'teamtailor-integration': v.optional(v.boolean()),
  'alexishr-integration': v.optional(v.boolean()),
  autoenroll: v.optional(v.boolean()),
  sociallogin: v.optional(v.boolean()),
  autobee: v.optional(v.boolean()),
  altcbweb: v.optional(v.boolean()),
  cert: v.optional(v.boolean()),
  aleconv: v.optional(v.boolean()),
  quizbuilder: v.optional(v.boolean()),
  'winlas-integration': v.optional(v.boolean()),
  pii: v.optional(v.boolean()),
  cdesign2: v.optional(v.boolean()),
  'dev-cert': v.optional(v.boolean()),
  confirmuserdetails: v.optional(v.boolean()),
  createblankproject: v.optional(v.boolean()),
  teamview: v.optional(v.boolean()),
  leweb: v.optional(v.boolean()),
  fragments: v.optional(v.boolean()),
  pitch: v.optional(v.boolean()),
  'sitevision-integration': v.optional(v.boolean()),
  quizwebng: v.optional(v.boolean()),
  reenroll: v.optional(v.boolean()),
  projectpeople: v.optional(v.boolean()),
  coursecatalogng: v.optional(v.boolean()),
  'dev-awardnotifications': v.optional(v.boolean()),
  flirt: v.optional(v.boolean()),
  catalogselfreg: v.optional(v.boolean()),
  rostersearchorg: v.optional(v.boolean()),
  zapier: v.optional(v.boolean()),
  waitlist: v.optional(v.boolean()),
  ptoggle: v.optional(v.boolean()),
  autoical: v.optional(v.boolean()),
  notifications: v.optional(v.boolean()),
  coursecatalog: v.optional(v.boolean()),
  credly: v.optional(v.boolean()),
  assignment2: v.optional(v.boolean()),
  larm: v.optional(v.boolean()),
  automations: v.optional(v.boolean()),
  'dev-diploma': v.optional(v.boolean()),
  roles: v.optional(v.boolean()),
  boanonproducts: v.optional(v.boolean()),
  segments: v.optional(v.boolean()),
  dashboarduserslots: v.optional(v.boolean()),
  award: v.optional(v.boolean()),
  uploadassignment: v.optional(v.boolean()),
  sms: v.optional(v.boolean()),
  logingoogle: v.optional(v.boolean()),
  rememberlogin: v.optional(v.boolean()),
  social: v.optional(v.boolean()),
  deeplink: v.optional(v.boolean()),
  'dev-dashboarduserslots': v.optional(v.boolean()),
  loginlinkedin: v.optional(v.boolean()),
  nativenotifications: v.optional(v.boolean()),
  ccadminng: v.optional(v.boolean()),
  chat: v.optional(v.boolean()),
  contentbrowser: v.optional(v.boolean()),
  catalogadmin: v.optional(v.boolean()),
  switchadminlanguage: v.optional(v.boolean()),
  'fe-core-header-goto': v.optional(v.boolean()),
  'fe-leaner-nextgen-discussions': v.optional(v.boolean()),
  'fe-core-header-settings': v.optional(v.boolean()),
  'report-customization': v.optional(v.boolean()),
  'nextgenui-default': v.optional(v.boolean()),
  'fe-core-header-ng-chat': v.optional(v.boolean()),
  'fe-core-header-ng-search': v.optional(v.boolean()),
  'fe-core-header-ng-search-learner': v.optional(v.boolean()),
  'fe-learner-teamview': v.optional(v.boolean()),
  'fe-learner-teamview-default': v.optional(v.boolean()),
  'fe-learner-microlearnings': v.optional(v.boolean()),
  'ai-azure-project-creation': v.optional(v.boolean()),
  'fe-learner-start-page': v.optional(v.boolean()),
  'fe-learner-assignments-v4': v.optional(v.boolean()),
  'project-bulk-upload': v.optional(v.boolean()),
});
